import { AppData, Colors, Lightning, Log, Img } from '@lightningjs/sdk'
import { SelectScreenInfo, SelectScreenOptionInfo } from '../lib/app-api-config'
import { AppSetup } from '../lib/app-setup'
import { Column, Row, Button, ButtonSmall, Artwork } from '@lightningjs/ui-components'
import SelectScreenTile from '../lib/components/grid/SelectScreenTile/SelectScreenTile'
import Router from '@lightningjs/sdk/src/Router'
import { Grid } from '@lightningjs/ui'
import TwoRowScreenTile from '../lib/components/grid/TwoRowScreenTile/TwoRowScreenTile'
import { Helper } from '../lib/helper'
import TwoRowThumb from '../lib/components/grid/TwoRowScreenTile/TwoRowThumb'
import TwoRowThumb2 from '../lib/components/grid/TwoRowScreenTile/TwoRowThumb2'
import { KeyCodes } from '../lib/key-codes'
import { IDialogueInfo } from '../lib/interfaces'
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from '../lib/enum'

export interface TwoRowSelectScreenTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Background: object
    Title: object
    SelectList: Column
}

export interface TwoRowSelectScreenTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true
}

export default class TwoRowSelectScreen
    extends Lightning.Component<TwoRowSelectScreenTemplateSpec, TwoRowSelectScreenTypeConfig>
    implements Lightning.Component<TwoRowSelectScreenTemplateSpec> {

    SelectList = this.getByRef('SelectList')!
    Skip = this.getByRef('Skip')!
    combinedRows = []


    static override _template(): Lightning.Component.Template<TwoRowSelectScreenTemplateSpec> {
        // const { appState } = AppData as AppSetup
        // const twoRowSelectScreenObject: SelectScreenInfo | undefined =
        //   appState?.getAppApiConfig()?.appConfig?.selectscreen
        // Log.info('SelectScreen:', twoRowSelectScreenObject)

        return {
            w: 1920,
            h: 1080,
            rect: true,
            color: 0x00222222,
            collision: true,
            Background: {
                w: 1920,
                h: 1080,
                src: '',
            },
            Image: {
                x: (w) => w / 2 + 60,
                y: 30,
                mount: 0.5,
                fixed: true,
                src: '',
            },
            SelectList: {
                x: 0,
                y: 0,
                type: TwoRowScreenTile,
                collision: true,
                zIndex: 4,
            },
            Skip: {
                x: (w) => w / 2,
                y: 1042,
                w: 414,
                h: 72,
                mountX: 0.5,
                mountY: 1,
                zIndex: 10,
                collision: true,
                type: TwoRowThumb2,
                rowIndex: 2
            }
        }
    }

    $optionsFocused(rowIndex, itemIndex) {
        this.selectedRow = rowIndex
        this.selectedColumn = itemIndex
    }

    override _setup() {
        const { appState } = AppData as AppSetup
        this.selectScreenInfo = appState?.getAppApiConfig()?.appConfig?.selectscreen

        const selectScreenOptions = this.selectScreenInfo?.options
        this.noOfRowItems = Math.round(selectScreenOptions.length / 2)
        this.selectScreenInfo.optimgw = 1920 / this.noOfRowItems
        this.selectScreenInfo.optimgh = 1080 / 2

        // const Row1 = selectScreenOptions?.filter(item => parseInt(item.l1_mapping, 10) < this.noOfRowItems)
        // const Row2 = selectScreenOptions?.filter(item => parseInt(item.l1_mapping, 10) >= this.noOfRowItems)
        const Row1 = []
        const Row2 = []
        selectScreenOptions?.map((item, index) => {
            if (index < this.noOfRowItems) {
                Row1.push(item)
            } else {
                Row2.push(item)
            }
        })

        this.combinedRows = [Row1, Row2]
        this.tag('Skip').imgSrc = this.selectScreenInfo?.skipimg
        this.tag('Skip').selectedImgSrc = this.selectScreenInfo?.skipimgSelect
        this._update()
        this._setState("SelectList")
        //this.checkImageDimensions(Row1[0].img)
    }

    _update() {
        const { appState } = AppData as AppSetup
        this.tag('Background').patch({ src: this.selectScreenInfo?.bgImg });
        this.tag('SelectList').patch({ combinedRows: this.combinedRows, selectScreenInfo: this.selectScreenInfo })
        this.tag('Image').patch({ src: appState?.getAppApiConfig()?.appConfig.header_logo })


        //this._setState("SelectList")
    }

    checkImageDimensions(url) {
        const img = new Image();
        img.onload = function () {
            //console.log(img, img.width, img.height, this.selectScreenInfo)
            this.selectScreenInfo.optimgw = img.width.toString()
            //this.selectScreenInfo.optimgh = img.height.toString()
            this._update()
        }.bind(this)
        img.src = url;
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        if (e.keyCode == KeyCodes.KEY_EXIT) {
            const { appState } = AppData as AppSetup
            const app = appState?.getApp()
            app?.handleAppExit()
            return true
        }
    }

    override _handleBack() {
        Router.navigate('main-grid-screen/' + 0, false)
    }
    // override _handleLeft() {

    //     if (this.selectedColumn === 0) {
    //         if (this.selectedRow === 0) {
    //             // Shift to the last tile of Row 2
    //             this.selectedRow = 1;
    //             this.selectedColumn = this.noOfRowItems - 1;
    //         } else {
    //             // Shift to the last tile of Row 1
    //             this.selectedRow = 0;
    //             this.selectedColumn = this.noOfRowItems - 1;
    //         }
    //     } else {
    //         this.selectedColumn--;
    //     }
    //     console.log("SelectList _handleLeft ", this.selectedRow, this.selectedColumn);
    //     // this.tag("SelectList").element.setIndex([this.selectedRow , this.selectedColumn])
    //     // this.tag("SelectList").tag('Wrapper')._Items.children[this.selectedRow].selectedIndex = this.selectedColumn
    //     this.tag("SelectList").tag('Wrapper').selectedIndex = this.selectedRow
    //     this.tag("SelectList").tag('Wrapper').selected.selectedIndex = this.selectedColumn


    // }
    // override _handleRight() {

    //     if (this.selectedColumn === this.noOfRowItems - 1) {
    //         if (this.selectedRow === 0) {
    //             // Shift to the last tile of Row 2
    //             this.selectedRow = 1;
    //             this.selectedColumn = 0;
    //         } else {
    //             // Shift to the last tile of Row 1
    //             this.selectedRow = 0;
    //             this.selectedColumn = 0;
    //         }
    //     } else {
    //         this.selectedColumn--;
    //     }
    //     console.log("SelectList _handleLeft ", this.selectedRow, this.selectedColumn);
    //     // this.tag("SelectList").element.setIndex([this.selectedRow , this.selectedColumn])
    //     // this.tag("SelectList").tag('Wrapper')._Items.children[this.selectedRow].selectedIndex = this.selectedColumn
    //     this.tag("SelectList").tag('Wrapper').selected.selectedIndex = this.selectedColumn
    //     this.tag("SelectList").tag('Wrapper').selectedIndex = this.selectedRow


    // }
    $handleThumbClick() {
        this._handleEnter()
    }

    override _handleEnter() {
        // const { appState } = AppData as AppSetup
        // const app = appState?.getApp()
        const index = (this.selectedRow * this.noOfRowItems) + this.selectedColumn
        const item: SelectScreenOptionInfo = this.selectScreenInfo?.options[index]
        Log.info("handleEnter l1", item.title);
        if (item.blockItem) {
            //this.widgets.notification.showMessage('')
            const dialogInfo: IDialogueInfo = {
                title: 'Uh-Oh',
                body: 'Please unblock to play content',
                type: DIALOG_TYPE.ALERT,
                buttons: [
                    {
                        w: 250,
                        name: 'Ok',
                        index: 0,
                        action: DIALOG_BUTTON_ACTION.CLOSE,
                        initialFocus: true,
                    }
                ]
            }
            this.widgets.dialog.showDialog(dialogInfo)
            Router.focusWidget('dialog')
            return true
        } 
        //app?.loadL1(item.l1_mapping)
        Router.navigate('main-grid-screen/' + item.l1_mapping, false)
    }
    override _handleDown() {
        Log.info("handledown selectlist");
        this._setState('Skip')
        return true
    }

    static override _states() {
        return [
            class SelectList extends this{
                override _getFocused() {
                    Log.info('SelectList: SelectList _focus: ')
                    return this.tag('SelectList')!
                }
            },
            class Skip extends this{
                override _getFocused() {
                    Log.info('SkipButton: SkipButton _focus: ', this.tag('Skip'))
                    const { platform } = AppData as AppSetup;
                    platform?.textToSpeach('Skip')

                    return this.tag('Skip') || null
                }
                override _handleUp() {
                    Log.info("handleup button");
                    this._setState('SelectList')
                    return true
                }
                override _handleEnter() {
                    Router.navigate('main-grid-screen/' + 0, false)
                }
            }
        ];
    }

}
